<template>
	<div class="userWizard">
		<div class="panel panel-plain" v-if="!upgradeComplete">
			<div class="panel-heading">
				<h2 class="panel-title">
					Complete the following entries to finalize your account upgrade.
				</h2>
			</div> 
			<div class="panel-body cwp splash-container-op" style="min-height: 40vh;">
				<div class="row">
					<div class="col-xs-12">
						<h4 v-if="forceNewPassword">Update Username and Password</h4>
						<h4 v-else>Click complete to finish the upgrade.</h4>
					</div>
				</div>
				<div class="row">
					<form v-if="pageInitted">
						<div class="col-xs-12" style="min-height: 58px; margin-bottom: 5px;">
							<label for="j_username" class="col-xs-12">
								Username
							</label>
							<!-- If current username is good use it else prompt for new username -->
							<div class="col-xs-12" v-if="!keepUserIdIfCan || !(newUserName.toString() === userID.toString() && !!usernameResp.status && usernameResp.status === 'OK')">
								<input name="j_username" class="form-control username" 
									v-model="newUserName" 
									autocomplete="off" 
									maxlength="40"
									@keyup="searchTimeOut()" />
								<p v-if="newUserName.toString().length === 0" class="help-block text-danger">*Username is required</p>
								<p v-else-if="!!usernameResp.message" 
									:class="{ 	'help-block': true, 
												'text-success': usernameResp.status === 'OK',
												'text-danger': usernameResp.status !== 'OK' 
											}"
								>*{{usernameResp.message}}</p>
								<p v-else class="help-block"><font-awesome-icon icon="spinner" spin></font-awesome-icon></p>
							</div>
							<div class="col-xs-12" v-else>
								<input name="j_username" class="form-control username" 
									v-model="newUserName" 
									autocomplete="off" 
									maxlength="40"
									readonly
									disabled />
							</div>
							<template v-if="forceNewPassword">
								<label for="j_password" class="col-xs-12">
									New Password
								</label>
								<div class="col-xs-12">
									<password
										v-model="newPassword"
										:toggle="true"
										:secureLength="passwordMinLegth"
										:showStrengthMeter="true"
										name="j_password"
										autocomplete="new-password"
										maxlength="40"
									/>
								</div>
								<label for="j_password2" class="col-xs-12">
									Confirm New Password
								</label>
								<div class="col-xs-12">
									<password
										v-model="newPasswordMatch"
										:toggle="true"
										:secureLength="passwordMinLegth"
										:showStrengthMeter="true"
										name="j_password2"
										autocomplete="new-password"
										maxlength="40"
									/>
									<p v-if="passwordMessage > 0" class="help-block text-danger" >
										<span v-if="passwordMessage === 1">
											Password must must have the following characteristics: 
											<ul>
												<li>At least {{passwordMinLegth}} characters - the more characters, the better.</li>
												<li>A mixture of letters and numbers.</li>
											</ul>	
										</span>
										
										<span v-if="passwordMessage === 2">Confirm password does not match</span>
										
									</p>
								</div>
							</template>
							<div v-else>

							</div>
						</div>
					</form>
				</div>
				
			</div> 
			<div class="panel-footer container-fluid">
				<button class="btn btn-primary next pull-right" type="button" :disabled="!formReady || clicked" @click="isCWPPasswordUsed"> 
					Complete
				</button>
			</div>
		</div>
		<div v-else class="text-center">
			<h1>Upgrade Complete</h1>
			<fireworks :boxHeight="'100%'" :boxWidth="'100%'" />
			<p>You will be redirected to the home screen.</p>
		</div>

		<!-- Modal -->
		<modal modal-title="Portal Alert!" :show="showModal" dialog-size="sm" name="passwordModal" @close="closeModal()">
			<template>
				<p class="text-center text-muted">
					{{ModalText}}
				</p>
			</template>
			<template slot="footer">
				<button type="button" class="btn btn-transparent pull-right" @click="closeModal()">
					{{ $t('MAIN_CONTENT.commonContent.closeButton') }}
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';
	import Password from 'vue-password-strength-meter'
	import Profile from '../../api/Profile';
	import UserConversion from '../../api/UserConversion';
	import fireworks from './fireworks.vue';
	import Modal from 'COMMONS/shared/Modal/Modal.vue';
	export default {
		data() {
			return {
				passwordMinLegth:8,
				isLoading:  true,
				usernameResp:{},
				newUserName:"",
				newPassword:"",
				newPasswordMatch:"",
				timer:null,
				pageInitted: false,
				upgradeComplete:false,
				showModal: false,
				ModalText:"",
				forceNewPassword:true,
				originalPassword:"",
				url:"",
				clicked: false
			}
		},
		computed: {
			...mapGetters(['userGuid', 'userID', 'role','selectedStudent']),
			formReady(){
				return  (!this.forceNewPassword || this.passwordMessage === 0)  
						&& !!this.usernameResp.status
						&& this.usernameResp.status === "OK";
			},
			passwordMessage(){
				let alpha = /[a-zA-Z]/,
				number = /[0-9]/,
				minLength = this.passwordMinLegth;
				/* check length */
				if(this.newPassword.length < minLength){
					return 1;
				}
				/* Check A mixture of letters and numbers */
				else if(!alpha.test(this.newPassword) || !number.test(this.newPassword)){
					return 1;
				}
				/* Make sure confirm password matches */
				else if(this.newPassword !== this.newPasswordMatch){
					return 2;
				}
				/* else basic check password change is good */
				return 0;
			},
			/* force students to keep username if its available */
			keepUserIdIfCan(){
				return this.role === "student" ? true: false;
			}
		},
		components: {
			Password, 
			fireworks,
			Modal
		},
		methods: {
			...mapActions(['resetSelectedStudentRID']),
			pageLoaded() {
				this.isLoading = false;
			},
			searchTimeOut() {  
				this.usernameResp = {};
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
				this.timer = setTimeout(() => {
					this.isCWPUsernameTaken()
				}, 800);
			},
			isCWPUsernameTaken() {
				/* clean out any whitespace */
				this.newUserName = this.newUserName.toString().replace(/\s+/g, '');
				/* if blank stop */
				if(!this.newUserName){
					return;
				}

				let profile = new Profile({
					routeParams: { setting: 'check-user' },
					query: {
						'new_username': this.newUserName,
						'user_guid': this.userGuid,
						'role': this.role,
						'student_rid': this.role === "student" ? this.selectedStudent.STUDENT_RID : "",
						'original_password': this.originalPassword
					}
				});

				const promise = profile.get();

				promise.then(response => {
					this.usernameResp = response.data.data;
					this.pageInitted = true;
					/* we we get this key value back dont force pw change */
					if(!!this.usernameResp.passwordStatus && this.usernameResp.passwordStatus === "OK"){
						this.forceNewPassword = false;
					}
					else{
						this.forceNewPassword = true;
					}
				})
			},
			isCWPPasswordUsed(){
				this.clicked = true;
				/* if password is not valid stop */
				if(this.forceNewPassword && this.passwordMessage !== 0){
					this.clicked = false;
					return false;
				}

				let profile = new Profile({
					routeParams: { setting: 'check-password' },
					data: {
						'new_username':this.newUserName,
						'new_password': this.forceNewPassword ? this.newPassword : this.originalPassword,
						'user_guid': this.role === "student" ? this.userGuid : "",
						'role': this.role,
						'student_rid': this.role === "student" ? this.selectedStudent.STUDENT_RID : "",
						'original_password': this.originalPassword
					}
				});

				const promise = profile.post();

				promise.then(response => {
					let passwordResp = response.data.data;
					if(!!passwordResp.status && passwordResp.status === "OK"){
						this.convertAccount();
					}
					else{
						/* fix wording for student account whose password was used. */
						if(this.role === 'student' && !this.forceNewPassword){
							this.ModalText = "This account requires a new password. Please enter your new password to continue.";
						}else{
							this.ModalText = passwordResp.message;
						}
						
						this.showModal = true;
						/* else someone took the password with the same username after screen loaded, so force change*/
						this.forceNewPassword = true;
						
					}
					setTimeout(()=>{
						this.clicked = false;
					}, 3000);
					
				})
			},
			convertAccount(){
				/* if password is not valid stop */
				if(this.forceNewPassword && this.passwordMessage !== 0){
					return false;
				}

				let profile = new Profile({
					routeParams: { setting: 'upgrade-account' },
					data: {
						'new_username': this.newUserName,
						'new_password': this.forceNewPassword ? this.newPassword : this.originalPassword,
						'user_guid': this.role === "student" ? this.userGuid : "",
						'role': this.role,
						'student_rid': this.role === "student" ? this.selectedStudent.STUDENT_RID : ""
					}
				});

				const promise = profile.post();

				promise.then(response => {
					let upgradeResp = response.data.data;
					if(!!upgradeResp.status && upgradeResp.status === "OK"){
						this.clearStudentPWData();
					}
					else{
						this.ModalText = upgradeResp.message;
						this.showModal = true;
						this.isCWPUsernameTaken();
						this.clicked = false;
					}
				})
			},
			success(){
				/* Clear credtype we dont need it anymore */
				this.$store.commit('setCredType', "LCLPW");
				this.$store.commit('setTitle', '');
				this.upgradeComplete = true;
				/* push user to home page */
				setTimeout(() => {
					this.goToHome();
				}, 5000);
			},
			goToHome(){
				if(this.role === 'parent') {
					if(this.$store.state.students.length > 1) {
						this.resetSelectedStudentRID();
					}

					this.$route.name === 'HomePage' ?
						this.$router.push({ name: 'ParentHome' }) :
						this.$router.push({ name: 'HomePage' });
				} else {
					this.$router.push({ name: 'HomePage' });
				}
			},
			closeModal() {
				this.showModal = false;
				this.ModalText = "";
			},
			fetchStudentPWData(){
				let UserConv = new UserConversion({
					baseUrl: this.url + '/CommunityWebPortal/_auth/index.cfm/',
					route: "security/user-conversion"
				});

				UserConv.get().then(response => {
					let rsp = response.data;
					this.originalPassword = rsp.temp;
					this.isCWPUsernameTaken();
				});
			},
			clearStudentPWData(){
				let UserConv = new UserConversion({
					baseUrl: this.url + '/CommunityWebPortal/_auth/index.cfm/',
					route: "security/user-conversion-done"
				});
				UserConv.get().then((response)=>{
					this.success();
				});
			}
		},
		mounted() {
			this.$nextTick(()=> {
				this.url = window.location.protocol+"//"+window.location.host;
				if(!window.location.port) {}
				else if(window.location.protocol==="http:" && window.location.port==80) {}
				else if(window.location.protocol==="https:" && window.location.port==443) {}
				else {
					this.url  = `${this.url }:${+window.location.port}`;
				}
				this.$store.commit('setTitleIcon', '');
				this.$store.commit('setTitle', 'Sapphire Portal 2.0 Account Upgrade');
				this.$store.commit('setUseHeader', true);
				this.newUserName = this.userID.toString();
				this.fetchStudentPWData();
			});
		}
	}
</script>

<style scoped>
	.help-block{
		margin-left:5px;
	}
	.text-success{
		color:#3c763d !important;
	}
	.text-danger{
		color:#a94442 !important;
	}

</style>
